import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICoreSettings, ICoreSettingsReducer } from '../../types/coreSettings'
import { fetchProductCoreSettings } from '../async-thunks/coreSettings/fetchProductCoreSettings'

const initialState: ICoreSettingsReducer = {
    isLoading: false,
    error: '',
    productsCoreSettings: {},
}

const coreSettingsSlice = createSlice({
    name: 'coreSettingsSlice',
    initialState,
    reducers: {
        modifyCoreSettings: (
            state,
            action: PayloadAction<{
                guid: string
                data: ICoreSettings
            }>
        ) => {
            state.productsCoreSettings[action.payload.guid] =
                action.payload.data
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchProductCoreSettings.pending, state => {
            state.isLoading = true
            state.error = ''
        })
        builder.addCase(fetchProductCoreSettings.fulfilled, (state, action: PayloadAction<{
            guid: string
            data: any
        }>) => {
            state.isLoading = false
            state.error = ''
            state.productsCoreSettings[action.payload.guid] = action.payload.data
        })
        builder.addCase(fetchProductCoreSettings.rejected, state => {
            state.isLoading = false
            state.error = 'errors.messages.onCoreSettingsFetch'
        })
    }
})

export const { actions: coreSettingsActions } = coreSettingsSlice
export const { reducer: coreSettingsReducer } = coreSettingsSlice
